<template>
    <div>
        <v-progress-linear indeterminate v-if="uxShowSpinner"
                           color="yellow darken-2"></v-progress-linear>
        <v-container fluid v-if="uxDisplay">
            <v-layout v-if="uxHasAccount">
                <v-flex xs12 sm6 offset-sm3>
                    Sie haben bereits einen Zugang: <br />
                    <span class="display-2">
                        {{uxAccount}}
                        <br />
                    </span>
                    <br />
                    erzeugt am {{uxCreated}}. <br />

                </v-flex>
            </v-layout> <!-- Already has an account -->
           

            <v-layout v-if="!uxAccount">
                <v-flex xs12 sm6 offset-sm3>


                    Geben Sie den vierstelligen Antragscode ein, den Sie in der Vorlesung erhalten haben (Gültig für die Vorlesungen ab SS 20).

                    <v-form class="mt-3" v-model="valid">

                        <v-text-field v-model="uxAntragscode"
                                      :rules="[rules.required, rules.min]"
                                      label="Antragscode"
                                      outline
                                      clearable
                                      required></v-text-field>
                    </v-form>

                    <v-btn small color="primary" :disabled="!valid" v-on:click="uiEvent('requestUserId')">
                        Zugang beantragen
                    </v-btn>

                   
                </v-flex>
            </v-layout> <!-- Access Code Form -->
            <v-layout v-if="uxShowLastMessage">
                <v-flex xs12 sm6 offset-sm3>


                    Hier ist ihr neuer SAP S/4Hana Account.  <br />
                    <span class="display-2">
                        {{uxAccount}}
                        <br />
                    </span>

                    Zur Nutzung des Zugangs brauchen Sie ein Initialkennwort. Das Konto muss in SAP freigeschaltet werden.
                    Sie erhalten Informationen bei Ihrem Dozenten.

                </v-flex>

            </v-layout> <!-- Closing Message -->
        </v-container> <!-- Container für SAP Antrag -->
    </div>
</template>

<script>
import firebase from "firebase/compat/app";
const firebaseFirestore = require("../myFirebase/firebaseFirestore.js");
import { Utils } from "./../classes/Utils.js";
import { FirebaseTable } from "./table/FirebaseTable.js";
export default {
  data() {
    return {
      fbTable: {},
      tName: "S4_M29_462",
      valid: false,
      uxShowSpinner: true,
      uxAntragscode: "",
      uxAccount: "",
      uxHasAccount: false,
      uxShowLastMessage: false,
      uxDisplay: false,
      uxCreated: "",

      validityCheck: true,
      rules: {
        required: (value) => !!value || "Required",
        min: (value) => value.length > 3 || "Mindestens 4 Zeichen",
      },
    };
  },

  async created() {
    console.log("CREATED called");
    let user = firebase.auth().currentUser;
    this.fbTable = new FirebaseTable();
    let doc = await this.fbTable.read_by_key(this.tName, user.email);

    if (doc) {
      // There is an entry
      this.uxHasAccount = true;
      this.uxAccount = doc.account;
      this.uxCreated = Utils.getGermanDate(doc.timestamp.toDate());
    }

    console.log("... finished" + this.uxAccount);
    this.uxDisplay = true;
    this.uxShowSpinner = false;
  },

  methods: {
    async uiEvent(event) {
      let user = firebase.auth().currentUser;

      let tInfo;
      let account_id;
      let prefix, account, entry;
      switch (event) {
        case "back":
          this.$router.push({ name: "Landing" });
          break;

        case "requestUserId":
          this.uxShowSpinner = true;          

          // Read the access list header...
          tInfo = await this.fbTable.read_meta(this.tName);
         

          // This should never happen...
          if (!tInfo) {
            this.$store.commit(
              "setSnackbarText",
              "Interner Fehler: Ungültige Liste"
            );
            this.uxShowSpinner = false;
            return;
          } else {
            // Now we check the code...
            if (tInfo.meta.code !== this.uxAntragscode) {
              this.$store.commit(
                "setSnackbarText",
                "Dieser Code ist ungültig."
              );
              this.uxShowSpinner = false;
              return;
            }
          }

          // STEP 2: Get a new  sap account     number
          account_id = await this.fbTable.get_and_increment(
            this.tName,
            "next_id"
          );

          // Leave, if there is an error in getting the id...
          if (account_id < 0){
            this.$store.commit(
              "setSnackbarText",
              "Bitte später nochmals versuchen! (account_id < 0)"
            );
            this.uxShowSpinner = false;
            return;
          }
          

          prefix = "";
          if (account_id < 10) {
            prefix = "00";
          } else if (account_id < 100) {
            prefix = "0";
          }

          account = prefix + account_id;

          account_id = "learn-" + account;

          entry = {
            email: user.email,
            code: this.uxAntragscode,
            account: account_id,
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            uid: user.uid,
            group: tInfo.meta.group,
          };
          console.log("xxx ", entry);
          var res = await this.fbTable.write_by_key(
            this.tName,
            entry.email,
            entry
          );

          if (res) {
            console.log("Created account : " + account_id);
            
                            let x  = await firebaseFirestore.write_mail("dg@dietergreipl.de",
                                "G24: Neuer S4 User: " + account_id + " für " + user.email,
                                "User Daten : " + user.email + " Uid = " + user.uid);
  
          } else {
            this.$store.commit(
              "setSnackbarText",
              "Es konnte kein freier Zugang gefunden werden."
            );
             this.uxShowSpinner = false;
            return;
          }

          // Finally Update the userobject with the gbi - account
          this.$store.commit("setGBIAccount", account_id);

          this.uxAccount = account_id;
          this.uxShowForm = false;
          this.uxShowSpinner = false;
          this.uxShowLastMessage = true;
          this.uxShowSpinner = false;
          break;
      }
    },
  },

  // Heavy nach jeder Eingabe aufgerufen!
  updated: function() {
    this.$nextTick(function() {});
  },
};
</script>

<style scoped>
</style>
